import React from 'react';
import styled from 'styled-components';
import Wrapper from '@common/Wrapper';

import logo from '@src/static/logo_white.svg';

const FooterWrapper = styled.footer`
  width: 100vw;
  padding: 10px;
  background: ${p =>
    p.theme.dark ? p.theme.secondaryColor : p.theme.gradient};

  p {
    font-size: 1rem;
    line-height: 35px;
    color: white;
  }

  a {
    color: ${p =>
      p.theme.dark ? p.theme.primaryColor : p.theme.secondaryColor};
    &:hover {
      color: ${p => p.theme.primaryText};
    }
  }
`;

const Footer = () => (
  <FooterWrapper>
    <Wrapper>
      <FlexDiv>
        <img width="35px" src={logo} alt="daniel komolafe" />

        <div className="connvei">
          <h3>
            <a
              href={`https://${process.env.GATSBY_BLOG}`}
              target="_blank"
              rel="noreferrer"
              style={{ color: '#6D83F2' }}
            >
              Connvei
            </a>
          </h3>
        </div>

        <p>
          Made with love and
          <a href="https://gatsbyjs.org" target="__blank">
            &nbsp;gatsby
          </a>
          .&nbsp; Inspired by
          <a href="https://github.com/anuraghazra" target="__blank">
            &nbsp;anuraghazra
          </a>
        </p>
      </FlexDiv>
    </Wrapper>
  </FooterWrapper>
);

const FlexDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  .connvei {
    font-family: 'Permanent Marker', cursive;
  }
`;

export default Footer;
